import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.DearRequestCard', {
    sectionTitleSupplierDetails: 'Supplier details',
    sectionTitleAccountingDetails: 'Accounting details',
    sectionTitleShippingDetails: 'Shipping details',
    fieldSupplier: 'Supplier',
    fieldContact: 'Contact',
    fieldPhone: 'Phone',
    fieldApproach: 'Approach',
    fieldTerms: 'Terms',
    fieldRequiredByDate: 'Required by',
    fieldInventoryAccount: 'Inventory account',
    fieldTaxCalculation: 'Tax inclusive',
    fieldTaxCalculationValueYes: 'Yes',
    fieldTaxCalculationValueNo: 'No',
    fieldTaxRule: 'Tax rule',
    fieldOrderDate: 'Date',
    fieldLocation: 'Location',
    fieldShippingAddress: 'Shipping address',
    fieldBillingAddress: 'Vendor address',
    fieldNote: 'Comment',
    fieldMemo: 'Purchase order memo',
});
